import { Button } from "@primitives/button";
import { ChevronLeft } from "lucide-react";
import { useNavigationState } from "@/zustand/NavigationState";
import { Input } from "@primitives/input";
import { useState } from "react";
import { useDebounce } from "@uidotdev/usehooks";
import { SEARCH_DEBOUNCE_TIME } from "@/config/constants";
import { useTranslation } from "react-i18next";
import ChatList from "./ChatList";
import { ChatType } from "@/server/types/chat";

export default function SearchP2PChatView() {
  const { t } = useTranslation();
  const setChatUserAction = useNavigationState(
    (state) => state.setChatUserAction,
  );

  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, SEARCH_DEBOUNCE_TIME);

  return (
    <div
      id="SearchP2PChatView"
      className="absolute left-0 top-[env(safe-area-inset-top,0px)] flex h-[calc(100%-env(safe-area-inset-top,0px))] w-full flex-col overflow-hidden bg-card lg:top-0 lg:h-full"
    >
      <div className="flex h-leftColumnHeaderHeight shrink-0 items-center border-b border-primary/20 px-4">
        <Button
          className="mr-2"
          size="icon"
          variant="ghost"
          onClick={() => setChatUserAction(null)}
        >
          <ChevronLeft />
        </Button>
        <h2 className="truncate text-lg font-semibold leading-tight">
          {t("directMessages")}
        </h2>
      </div>
      <div className="mt-2 flex px-4 py-1">
        <Input
          autoFocus
          defaultValue={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value.toLocaleLowerCase())}
          type="text"
          placeholder={t("searchChatName")}
          className="h-8 bg-foreground/10"
        />
      </div>
      <div className="flex flex-1 flex-col overflow-hidden p-3">
        <ChatList searchTerm={debouncedSearchTerm} chatType={ChatType.P2P} />
      </div>
    </div>
  );
}
